export default "__VITE_ASSET__DxcILgmG__"